export default __webpack_public_path__ + "static/media/boy-working.983559de.svg";